import { Grid, InputLabel, MenuItem } from '@material-ui/core'
import StandardTable from 'asterX-UI/Table/StandardTable'
import React, { useEffect, useState } from 'react'
import { useContractStore } from 'context/ContractStore'
import { NotFound } from 'components/NotFound/NotFound'
import { useAuthStore } from 'context/AuthStore'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { SelectPlaceholder } from 'asterX-UI/Inputs'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useSnackbar } from 'notistack'
import { CollectionService } from 'lib/api/services/collection.service'
import { eventHistoryColumns, eventHistoryRows } from './const'
import { useStyles } from './events-history.styles'

export const EventsHistory = () => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()

  const { authStoreFunc } = useAuthStore()
  const {
    contractStore: { events, contractAll, statuses, eventHistory },
    contractStoreFunc
  } = useContractStore()

  const [openModal, setOpenModal] = useState(false)
  const [currentRowData, setCurrentRowData] = useState(null)

  const selectedEvent = statuses?.list?.find(item => item?.eventTypeCode === currentRowData?.type?.code)

  const combinedEvents = [...(contractAll?.events || []), ...(eventHistory || [])]

  const tableData = {
    columns: eventHistoryColumns,
    rows: eventHistoryRows(combinedEvents)
  }

  useEffect(() => {
    if (combinedEvents?.length > 0) {
      contractStoreFunc.getStatuses()
    }
    contractStoreFunc.findByContract()
  }, [])

  const handleOpenRow = row => {
    const current = contractAll?.events.find(e => e?.id === row?.id)
    if (!current?.result && authStoreFunc.isManager()) {
      setCurrentRowData(current)
      setOpenModal(true)
    }
  }

  const handleClose = () => {
    setOpenModal(false)
    contractStoreFunc.clearEvents()
  }

  const handleSendEventsResultCode = async () => {
    const missingFields = []

    if (!events?.eventResultCode) {
      missingFields.push('Выбрать результат')
    }

    if (missingFields.length > 0) {
      enqueueSnackbar(`😿 Заполните поле(я): ${missingFields.join(', ')}`, { variant: 'info' })
      return
    }

    const data = {
      id: Number(currentRowData?.id),
      eventResultCode: events.eventResultCode
    }

    await CollectionService.patchEvents(data)
      .then(res => {
        if (res.data) {
          enqueueSnackbar('Успешно 😸', { variant: 'success' })
          handleClose()
          contractStoreFunc.getById()
        } else {
          enqueueSnackbar(`😿 Что-то пошло не так, статус ${res?.status}`, { variant: 'error' })
          return
        }
      })
      .finally(() => {})
  }

  return (
    <Grid container className={contractAll?.events?.length > 0 ? classes.wrapper : ''}>
      {combinedEvents?.length > 0 ? (
        <StandardTable
          tableData={tableData}
          onButtonClick={handleOpenRow}
          btnStyle={{ backgroundColor: 'transparent', border: 'none', padding: 8, minWidth: 'auto' }}
        />
      ) : (
        <NotFound />
      )}

      <ActionModal
        open={openModal}
        onCancel={handleClose}
        onClose={handleClose}
        onConfirm={handleSendEventsResultCode}
        title="Добавить результат"
      >
        <Grid item container xs={12}>
          <Grid item xs={12}>
            <InputLabel shrink className={classes.inputLabel}>
              Выбрать результат *
            </InputLabel>
            <SelectPlaceholder
              IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
              value={events?.eventResultCode || null}
              name={'eventResultCode'}
              onChange={e => contractStoreFunc.handleEventsChange(e)}
              fullWidth
              placeholder={'Результат'}
            >
              <MenuItem value={''}>Не выбрано</MenuItem>
              {(selectedEvent?.eventResultList || []).map(result => (
                <MenuItem key={result?.code} value={result?.code}>
                  {result?.name}
                </MenuItem>
              ))}
            </SelectPlaceholder>
          </Grid>
        </Grid>
      </ActionModal>
    </Grid>
  )
}
